// extracted by mini-css-extract-plugin
export default {"auth-layout":"AuthLayout_auth-layout__2m1Rw","header-spacing":"AuthLayout_header-spacing__FzfXH"};